<template>
<v-app style="padding-top:130px;background-color:white">
    <v-layout row wrap>
      
      <v-flex xs12 sm12 md8>
        <div style="border:1px solid;" class="table-container">
          <h6>Address to Deliver</h6>
          <p class="covid">{{selectedAddress.name}}</p>
          <p class="covid">{{selectedAddress.mobileNumber}}</p>
          <p class="covid">{{selectedAddress.address}}</p>
          <p class="covid">{{selectedAddress.pinCode}}</p>
          <v-btn small depressed color="primary" @click.stop="addressDialog = true">Change or Add Address</v-btn>
        </div>
        <v-card flat class="table-container" style="background-color:#424242;margin-top:-30px">
           <v-data-table :headers="headers" hide-actions :items="orderDetails" :search="search" :loading="false">
      <v-progress-linear slot="progress" color="blue" indeterminate></v-progress-linear>
      <template slot="items" slot-scope="props">
        <tr>
          <td class="text-xs-left">
            <img height="70px" width="70px" style="padding:5px" :src=props.item.src />
            <p>{{props.item.itemName}}</p>
        </td>
        <td class="text-xs-left">₹ &nbsp;{{props.item.price.toFixed(2)}}</td>
        <td class="text-xs-center">{{props.item.quantity}}</td>
        <td class="text-xs-left">₹ &nbsp;{{props.item.totalPrice.toFixed(2)}}</td>
        <td class="text-xs-left">
          <v-icon small class="ml-3" color="#212121" @click="cart(props.item)">add</v-icon>
          <v-icon v-if="props.item.quantity > 1" small class="ml-2" color="#212121" @click="minuscart(props.item)">remove</v-icon>
        </td>
        <td class="text-xs-left"><v-icon small class="ml-3" color="#e53935" @click="removeFromCart(props.item)">delete</v-icon></td>
        </tr>
      </template>
      <v-alert
        slot="no-results"
        :value="true"
        color="error"
        icon="warning"
      >Your search for "{{ search }}" found no results.</v-alert>
    </v-data-table>
    </v-card>
      </v-flex>

      
      <v-flex xs12 sm12 md4>
        <v-card class="table-container" style="border: 1px solid; border-color:#4E97FD;">
          <h3>GRAND TOTAL</h3>
          <h4 style="text-align:right">₹ &nbsp;{{totalPrice}}</h4>
          <p style="text-align:right">(All Tax is Included)</p><br/>
          <b-form-radio-group
            v-model="selected1"
           :options="options1"
           stacked
          ></b-form-radio-group>
          <v-btn v-if="selected1=='Online Payment'" :disabled="$store.state.cartCount === 0" color="green" :loading="btnSave" large block dark depressed id="rzp-button1" @click="proceed1()">Proceed to checkout</v-btn>
          <v-btn v-if="selected1=='Cash on Delivery'" :disabled="$store.state.cartCount === 0" color="#e53935" :loading="btnSave" large block dark depressed @click="proceed()">Proceed to checkout</v-btn>
        </v-card>
      </v-flex>
      
    </v-layout>

    <v-dialog v-model="addressDialog" width="1000px">
      <v-card flat class="container">
              <h5 style="padding-top:100px">Select Your Address</h5>
              <v-autocomplete
                              dense
                              v-model="selectedAddress1"
                              :items="address"
                              label="Select Address"
                              item-text="address"
                              item-value="id"
                              persistent-hint
                              return-object
                              single-line
                              @change="changeAddress()"
                            ></v-autocomplete>
              <h5>Add an Address</h5>
              <v-form ref="form" v-model="valid" lazy-validation>
                <v-layout row wrap>
                  <v-flex xs12 sm12 md6 style="padding-right:5px">
                    <v-text-field v-model="form.name" label="Name *" :rules="emptyRule" required></v-text-field>
                  </v-flex>
                  <v-flex xs12 sm12 md6>
                    <v-text-field v-model="form.mobileNumber" label="Mobile No *" :rules="[rules.mobileno]" required></v-text-field>
                  </v-flex>
                  <v-flex xs12 sm12 md12>
                    <v-text-field v-model="form.locality" label="Locality *"  :rules="emptyRule" required></v-text-field>
                  </v-flex>
                  <v-flex xs12 sm12 md12>
                    <v-text-field v-model="form.address" label="Address *"  :rules="emptyRule" required></v-text-field>
                  </v-flex>
                  <v-flex xs12 sm12 md4 style="padding-right:5px">
                    <v-text-field v-model="form.pinCode" label="Pincode *" type="number"  :rules="emptyRule" required></v-text-field>
                  </v-flex>
                  <v-flex xs12 sm12 md4 style="padding-right:5px">
                    <v-text-field v-model="form.cityDistrictTown" label="City/Discrict/Town *"  :rules="emptyRule" required></v-text-field>
                  </v-flex>
                  <v-flex xs12 sm12 md4>
                    <v-autocomplete
              v-model="selectedState"
              :items="states"
              color="primary"
              label="Select State *"
              item-text="name"
              item-value="id"
              :rules="emptyRule" 
              required
            ></v-autocomplete>
                  </v-flex>
                  <v-flex xs12 sm12 md12>
                    <v-text-field v-model="form.landMark" label="Landmark *"  :rules="emptyRule" required></v-text-field>
                  </v-flex>

                  <v-flex xs12 sm12 md12>
                    <b-form-radio-group
                   v-model="selected"
                  :options="options"
                  ></b-form-radio-group>
                  </v-flex>

                  <v-flex xs12 style="text-align:right">
                    <v-btn depressed color="#e53935" dark @click.stop="addressDialog=false">Cancel</v-btn>
                    <v-btn depressed :loading="btnSave1" color="primary" dark @click="onSubmit()">Save & Continue </v-btn>
                  </v-flex>
                </v-layout>
              </v-form>
      </v-card>
    </v-dialog>


   <v-dialog v-model="orderDialog" width="500px">
     <v-card flat class="container">
       <h2 class="covid1" style="text-align:center">Your order placed successfuly</h2>
       <div style="text-align:center">
         <v-btn depressed color="primary" to="/myOrder">My Order</v-btn>
       </div>
     </v-card>
   </v-dialog>
</v-app>
</template>


<script>
import config from "./../../config.json";

export default {
  data() {
    return {
      search: "",
      orderDialog: false,
      deactive: false,
      btnSave: false,
      btnSave1: false,
      address: [],
      addressDialog: false,
      valid: true,
      selectedAddress: {
        id: null,
        name: null,
        mobileNumber: null,
        address: null,
        pinCode: null
      },
      selectedAddress1: null,

      form: {
        name: null,
        mobileNumber: null,
        pinCode: null,
        address: null,
        landMark: null,
        locality: null,
        cityDistrictTown: null,
        alternateNumber: null
      },

      selected: "Home Address",
      options: ["Home Address", "Office Address"],

      selected1: "Cash on Delivery",
      options1: ["Cash on Delivery", "Online Payment"],

      states: [],
      selectedState: null,

      headers: [
        { text: "PRODUCT", value: "name" },
        { text: "PRICE", value: "mrp" },
        { text: "QUANTITY", value: "qty" },
        { text: "SUB TOTAL", value: "sub" },
        { text: "ADD / MINUS", value: "sub" },
        { text: "REMOVE", value: "remove" }
      ],
      homePage: {
        productCategoryList: null,
      },
      orderDetails: this.$store.state.cart,
      loggedInUserID: sessionStorage.loggedInUserID,
      role: sessionStorage.roles,

      emptyRule: [v => !!v || "Input is required"],
      rules: {
        required: value => !!value || "Required.",
        mobileno: value => {
          const pattern = /^[1-9]{1}[0-9]{9}$/;
          return pattern.test(value) || "Mobile number not valid!!";
        },
      },
    };
  },

  methods: {
    cart(item) {
     this.$store.commit('addToCart', item);
   },
   minuscart(item) {
     this.$store.commit('minusToCart', item);
   },
    removeFromCart(item) {
        this.$store.commit('removeFromCart', item);
        window.location.reload();
    },

    category(cus) {
      this.$router.push("/categoryDetail/" + cus.id);
    },

    proceed() {
      if (sessionStorage.loggedInUserID != null) {
        if(this.selectedAddress.id == null || this.selectedAddress.id == 'undefined') {
          this.addressDialog = true;
        }
        else {
          this.btnSave = true;
        this.axios
          .post(
            config.API + `Orders`,
            {
              addressId: JSON.parse(this.selectedAddress.id),
              totalPrice: JSON.parse(this.totalPrice),
              paymentType: this.selected1,
              orderDetails: this.orderDetails
            },
            {
              headers: {
                Authorization: "bearer " + sessionStorage.getItem("token")
              }
            }
          )
          .then(() => {
            this.$toaster.success("Order Successfully placed");
            this.$store.commit('count');
            this.orderDialog = true;
            this.btnSave = false;
          })
          .catch(err => {
            this.$toaster.error(err.message);
            this.btnSave = false;
          });
        }
      }
      else {
        this.$router.push("/login");
      }
    },

    proceed1() {},

    getData() {
      if(sessionStorage.loggedInUserID != null) {
        this.axios
        .get(config.API + "CustomerAddresses/" + 1, {
          headers: {
            Authorization: "bearer " + sessionStorage.getItem("token")
          }
        })
        .then(res => {
          this.selectedAddress.id = res.data.id;
          this.selectedAddress.name = res.data.name;
          this.selectedAddress.mobileNumber = res.data.mobileNumber;
          this.selectedAddress.address = res.data.address;
          this.selectedAddress.pinCode = res.data.pinCode;
        })
      }
    },

    getData1() {
      this.axios
        .get(config.API + "CustomerAddresses", {
          headers: {
            Authorization: "bearer " + sessionStorage.getItem("token")
          }
        })
        .then(res => {
          this.address = res.data;
        });
    },

    onSubmit() {
      if (this.$refs.form.validate()) {
        this.btnSave1 = true;
        this.axios
          .post(
            config.API + `CustomerAddresses`,
            {
              name: this.form.name,
              mobileNumber: JSON.parse(this.form.mobileNumber),
              pinCode: JSON.parse(this.form.pinCode),
              address: this.form.address,
              locality: this.form.locality,
              cityDistrictTown: this.form.cityDistrictTown,
              landMark: this.form.landMark,
              alternateNumber: this.form.alternateNumber,
              stateCode: JSON.parse(this.selectedState),
              addressType: this.selected
            },
            {
              headers: {
                Authorization: "bearer " + sessionStorage.getItem("token")
              }
            }
          )
          .then(() => {
            this.$toaster.success("Successfully added");
            this.getData1();
            this.getData();
            this.btnSave1 = false;
            this.addressDialog = false;
          })
          .catch(err => {
            this.$toaster.error('"wong');
            this.btnSave1 = false;
          });
      } else {
        this.$toaster.error(`Required field are empty!!`);
      }
    },

    changeAddress() {
      this.selectedAddress.id = this.selectedAddress1.id;
      this.selectedAddress.name = this.selectedAddress1.name;
      this.selectedAddress.mobileNumber = this.selectedAddress1.mobileNumber;
      this.selectedAddress.address = this.selectedAddress1.address;
      this.selectedAddress.pinCode = this.selectedAddress1.pinCode;
      this.addressDialog = false;
    }
},

mounted() {
   this.getData();
   this.getData1();

        this.axios
        .get(config.API + "States", {
          headers: {
            Authorization: "bearer " + sessionStorage.getItem("token")
          }
        })
        .then(res => {
          this.states = res.data;
        });
  },

  computed: {
    totalPrice() {
        let total = 0;

        for (let item of this.$store.state.cart) {
            total += item.totalPrice;
        }

        return total.toFixed(2);
    }
}
};
</script>

<style scoped>
@import url('https://fonts.googleapis.com/css2?family=Quicksand:wght@300&display=swap');
</style>
<style>
.covid {
  font-family: 'Quicksand', sans-serif;
  font-size: 12px;
  font-weight: bold;
  margin: 0px;
}
.covid1 {
  font-family: 'Quicksand', sans-serif;
  font-weight: bold;
}
.point {
  cursor:pointer !important;
}
.bgc {
    background-color:#eeeeee !important;
}
</style>
